import { ShopsComponent } from './components/shops/shops.component';
import { RouterUtil } from '@us/web/shared/utils';
import { ShopComponent } from './components/shop/shop.component';

export const routes = [
    { path: '', component: ShopsComponent },
    {
        path: `:${RouterUtil.Cog.ShopId}`,
        component: ShopComponent
    }
];
